import React from "react";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import styled from "@emotion/styled";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";

interface FormNavProps {
  previousPageName?: string;
  previousPageLink?: string;
  nextPageName?: string;
  nextPageLink?: string;
}

const StyledDiv = styled.div`
  /* border: 2px solid lime; */
  margin-bottom: 1.2rem;

  .link {
    text-decoration: none;
  }

  .nav-container {
    /* border: 2px solid purple; */
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: small;
    font-weight: 600;
    font-family: "Roboto";
  }

  .button-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 0.3rem;
    cursor: pointer;
    color: #0abeff;
    /* border: 2px solid gray; */
    padding: none;
    height: fit-content;
    padding: 0 0.6rem;
    height: 35px;
    .disabled {
      color: #bdbdbd;
      cursor: auto;
    }
  }

  .nav-button {
    padding: 0;
  }

  .icon {
    font-size: 1.2rem;
    /* border: 2px solid greenyellow; */
  }
`;

const FormNav: React.FC<FormNavProps> = ({
  previousPageLink,
  nextPageLink,
  previousPageName,
  nextPageName,
}) => {
  return (
    <StyledDiv>
      <div className="nav-container">
        {previousPageName ? (
          <Link className="link" to={previousPageLink || ""}>
            <Button
              disabled={!Boolean(previousPageLink)}
              className="nav-button"
              variant="text"
            >
              <div
                className={`button-content ${
                  previousPageLink ? "" : "disabled"
                }`}
              >
                <ArrowBack className="icon" />
                <p>{previousPageName}</p>
              </div>
            </Button>
          </Link>
        ) : (
          <></>
        )}
        {nextPageName ? (
          <Link className="link" to={previousPageLink || ""}>
            <Button className="nav-button" variant="text">
              <div
                className={`button-content ${nextPageLink ? "" : "disabled"}`}
              >
                <p>{nextPageName}</p>
                <ArrowForward />
              </div>
            </Button>
          </Link>
        ) : (
          <></>
        )}
      </div>
    </StyledDiv>
  );
};

export default FormNav;
